import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-181b4e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "release-butterfly" }
const _hoisted_2 = { class: "container min-h-full m-auto flex flex-col text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "release-butterfly__title flex-none mt-auto mb-0" }, " It's time to let ", -1))
const _hoisted_4 = { class: "release-butterfly__name flex-none m-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "release-butterfly__title flex-none m-0" }, " Fly with its friends! ", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex flex-none my-auto" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Go Fly! ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-none uppercase font-bold my-auto" }, " Go find them on the video wall! ", -1))
const _hoisted_10 = { class: "flex flex-row flex-none" }
const _hoisted_11 = {
  ref: "canvasContainer",
  class: "absolute inset-0 pointer-events-none"
}
const _hoisted_12 = { ref: "canvas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_button = _resolveComponent("router-link-button")!
  const _component_back_button = _resolveComponent("back-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tap = _resolveDirective("tap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.butterflyName), 1),
      _hoisted_5,
      _createElementVNode("img", {
        src: _ctx.butterflySrc,
        class: "mx-8 opacity-0"
      }, null, 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createVNode(_component_router_link_button, { class: "m-auto" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 512), [
          [_directive_tap, _ctx.onClick]
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: _ctx.prevRoute,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_back_button, {
              class: "mr-auto",
              onClick: navigate
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("canvas", _hoisted_12, null, 512)
    ], 512)
  ]))
}